import { render, staticRenderFns } from "./ViewWatsonVraagbaakPage.vue?vue&type=template&id=23390a32&scoped=true&"
import script from "./ViewWatsonVraagbaakPage.vue?vue&type=script&lang=js&"
export * from "./ViewWatsonVraagbaakPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewWatsonVraagbaakPage.vue?vue&type=style&index=0&id=23390a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23390a32",
  null
  
)

export default component.exports